import { NgModule, ModuleWithProviders, Provider } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FISERV_CONFIG, FiservConfig } from './fiserv.config';
import { FiservPosPaymentService } from './pos/services/fiserv-pos-payment.service';
import { FiservPaymentMethodService } from './services/fiserv-payment-method.service';

function fiservProviders(config: FiservConfig): Provider[] {
  return [
    {
      provide: FiservPosPaymentService,
      useFactory: (h: HttpClient) => new FiservPosPaymentService(h, config),
      deps: [HttpClient]
    },
    {
      provide: FiservPaymentMethodService,
      useFactory: (h: HttpClient) => new FiservPaymentMethodService(h, config),
      deps: [HttpClient]
    },
  ];
}

/**
 * For standalone apps (app.config.ts):
 *
 *   import { provideHttpClient, withInterceptors } from '@angular/common/http';
 *   import { provideFiserv, fiservAuthInterceptorFn } from '@cmbsolutions/fiserv-angular';
 *   import store from 'store2';
 *
 *   provideFiserv({
 *     apiUrl: environment.fiservApiUrl,
 *     tokenFn: () => store.get('token') as string,
 *     branchId: () => store.get('userbranches') as string,
 *   })
 */
export function provideFiserv(config: FiservConfig): Provider[] {
  return [
    { provide: FISERV_CONFIG, useValue: config },
    ...fiservProviders(config),
  ];
}

@NgModule({})
export class FiservModule {
  static forRoot(config: FiservConfig): ModuleWithProviders<FiservModule> {
    return {
      ngModule: FiservModule,
      providers: [
        { provide: FISERV_CONFIG, useValue: config },
        ...fiservProviders(config),
      ],
    };
  }
}
